import permissions from '@/enums/permissions';

const fundLetters = [
    {
        path: '/documentos-fundos',
        name: 'fundLetters',
        component: () => import('@/views/pages/FundsHub/FundsHub.vue'),
        meta: {
            permissions: permissions.fundsHub,
        },
    },
];

export default fundLetters;
